import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScreenSize, useScreenSize } from "../../core/util/MediaQueries";
import { FlexContainer } from "../../core/components/FlexContainer";
import { Guesses } from "./Guesses";
import { VisualContainer } from '../../core/components/VisualContainer';
import { Font, FontWeight, TextElement } from '../../core/components/TextElement';
import { Contact3DPlayerList } from './Contact3DPlayerList';
export const Contact3DLowerSection = (props) => {
    const screenSize = useScreenSize();
    const { isCondensed, padding } = props;
    if (screenSize === ScreenSize.Large) {
        return _jsx(FlexContainer, { horizontal: true, flex: '1', gap: padding, children: _jsx(Guesses, {}) });
    }
    else {
        return (!isCondensed && _jsxs(FlexContainer, { horizontal: true, gap: '10px', style: { alignContent: 'space-between' }, children: [_jsx(Guesses, {}), _jsxs(VisualContainer, { padding: '10px', style: { paddingTop: '16px', flexBasis: '50%' }, gap: '14px', children: [_jsx(TextElement, { font: Font.Inter, fontSize: 16, fontWeight: FontWeight.Medium, color1: '#000000', text: 'Players', centered: true }), _jsx(Contact3DPlayerList, {})] })] }));
    }
};
//# sourceMappingURL=Contact3DLowerSection.js.map